// set sentry
import './sentry';

import Vue from 'vue';
// 引入 cube-ui
import Cube from 'cube-ui';
// 引入bridge
// import WebViewBridge from 'vue-bridge-webview';
// import dsbridge from 'dsbridge';
import './utils/vconsole';

import App from './App.vue';
// 引入路由
import router from './router';
// 引入 store
import store from './store';
// 引入过滤器
import Filters from './filters';
// 引入自定义组件库
import baseComponents from './components';

import $bridge from './utils/bridge';


Vue.prototype.$bridge = $bridge;

// 全局注册过滤器
Object.keys(Filters).forEach((item) => {
  Vue.filter(item, Filters[item]);
});
Vue.use(Cube);

Vue.use(baseComponents);

// for ios bridge
// Vue.use(WebViewBridge);
// for android bridge
// Vue.prototype.$bridge = dsbridge;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
